import React, { useEffect, useState } from 'react'
import "./RenderPopover.scss"
import Popover from '@mui/material/Popover';
import Select from "react-select"
import Button from 'react-bootstrap/esm/Button';
import Toast from "components/Toast"
import { categoryUpdate, getAllCategories, getSubCategoryByCategory, saveAdvancePayment } from 'core/services/api';

function RenderPopoverInsurance({ id, handleCloseInsurance, anchorElInsurance, openInsurance, invoice, category, subCategory, readOnly }: any) {


  const initialData = {
    categoryValue: invoice?.patientCategory || '',
    subCategoryValue: invoice?.subCategory || '',
    categoryId: invoice?.categoryId || ''
  }


  const [data, setData] = useState<any>(initialData);
  const [categoryDropdown, setCategoryDropdown] = useState<any>();
  const [subCategoryDropdown, setsubCategoryDropdown] = useState<any>();
  const [isCategorySelected, setIsCategorySelected] = useState<any>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false)


  useEffect(() => {
    if (openInsurance) {
      setData({
        categoryValue: invoice?.patientCategory || '',
        subCategoryValue: invoice?.subCategory || '',
        categoryId: invoice?.categoryId || ''
      });
    }
  }, [openInsurance]);





  useEffect(() => {
    getAllCategories()
      .then((res) => {
        const temp = res?.map((values: any) => {
          return {
            label: values,
            value: values,
          }
        })
        setCategoryDropdown(temp)
      })
      .catch((err) => {
        console.log("err", err)
      })
  }, [])

  useEffect(() => {
    if (data?.categoryValue) {
      getSubCategoryByCategory(data?.categoryValue)
        .then((res) => {

          const subDropdown = res?.map((values: any) => {
            return {
              label: values?.name,
              value: values?.id
            }

          })

          setsubCategoryDropdown(subDropdown)
        })
        .catch((err) => {
          console.log("err", err)
        })
    }
  }, [data?.categoryValue])

  // useEffect(() => {

  //   const defaultSubCategoryValue = subCategoryDropdown?.find((option: any) => option.label === data.subCategoryValue);

  //   if (defaultSubCategoryValue) {
  //     setData((prevData: any) => ({
  //       ...prevData,
  //       subCategoryValue: defaultSubCategoryValue.value
  //     }));
  //   }
  // }, [subCategoryDropdown]);

  const [displayToast, toggleDisplayToast] = useState<any>()
  const saveCategory = (() => {

    if (!data?.categoryId || data?.categoryId.trim() === "") {
      toggleDisplayToast({ text: "Please add subcategory", type: "error" });
      return;
    }
    // setIsLoading(true)
    categoryUpdate(data?.categoryId, invoice?.id).then((res: any) => {
      setIsLoading(false)
      toggleDisplayToast({ text: "Category details have been saved successfully", type: "success" });
    }).catch((err: any) => {
      console.log(err);
      setIsLoading(false)
      toggleDisplayToast({ text: "Unable to update Insurance details", type: "error" });
    });
  });

  const customStyles = {
    control: (provided: any, state: any) => ({
      ...provided,
      opacity: state.isDisabled ? 1 : 1,
      backgroundColor: state.isDisabled ? "white" : "white",
      cursor: state.isDisabled ? "not-allowed" : "pointer",
      border: "1px solid #ccd0e7",
      borderRadius: "10px"
    }),
  };

  const [isPopoverExpanded, setIsPopoverExpanded] = useState(false);
  const togglePopoverExpansion = (isOpen: any) => {
    setIsPopoverExpanded(isOpen);
  };



  return (
    <div className='popper-wrapper-insurance'>
      {isLoading && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            right: "50%",
          }}
        >
          <div
            style={{ width: "3rem", height: "3rem" }}
            className="spinner-border text-primary"
          ></div>
        </div>
      )}
      <Popover
        id={id}
        open={openInsurance}
        anchorEl={anchorElInsurance}
        onClose={handleCloseInsurance}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        sx={{ width: "100%" }}
      >
        <div className='popper-wrapper-insurance'
          style={{
            height: isPopoverExpanded ? '450px' : 'auto',
          }}>
          {/* <div className='blue-common-heading'>Insurance</div> */}
          <div className='wrapper-inputs-col'>
            <div style={{ height: "30px" }}></div>
            <div className="title-name">Category</div>
            <div className='category-select'>
              <Select
                className="select-payment"
                name="category"
                options={categoryDropdown}
                styles={customStyles}
                isDisabled={readOnly}
                value={{
                  label: data?.categoryValue,
                  value: data?.categoryValue,
                }}
                onChange={(evnt: any) => {
                  const temp = { ...data }
                  temp.categoryValue = evnt?.label
                  temp.subCategoryValue = ''
                  temp.categoryId = ''
                  setData(temp);
                  setIsCategorySelected(true);

                }}

              />
            </div>
          </div>
          <div className='wrapper-inputs-col'>
            <div className="title-name">Sub-Category</div>
            <div className='category-select'>
              <Select
                className="select-payment"
                name="modeOfPayment"
                styles={customStyles}
                isDisabled={!isCategorySelected || readOnly}
                value={{
                  label: data?.subCategoryValue,
                  value: data?.categoryId
                }}
                onMenuOpen={() => togglePopoverExpansion(true)} // Dropdown opened
                onMenuClose={() => togglePopoverExpansion(false)} // Dropdown closed
                options={subCategoryDropdown}
                onChange={(e: any) => {
                  const temp = { ...data }
                  // temp.subCategoryValue = evnt?.value
                  temp.subCategoryValue = e?.label;
                  temp.categoryId = e?.value;
                  setData(temp);
                }}

              />
            </div>
          </div>
          <Button className='common-button' disabled={readOnly} onClick={saveCategory}>Save</Button>
          <div style={{ height: "30px" }}></div>
          <div style={{ height: "30px" }}></div>
        </div>
      </Popover>
      {displayToast && (
        <Toast
          textMessage={displayToast?.text}
          type={displayToast?.type}
          onClose={() => {
            toggleDisplayToast(false)
            if (displayToast?.type === "success") {
              window.location.reload();
            }
          }}
          onCloseText="Close"
          onClickText={null}
        />
      )}
    </div>
  )
}

export default RenderPopoverInsurance

